var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 1C0.895431 1 0 1.89543 0 3C0 4.10457 0.895431 5 2 5H14C15.1046 5 16 4.10457 16 3C16 1.89543 15.1046 1 14 1H2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6H15V13C15 14.1046 14.1046 15 13 15H3C1.89543 15 1 14.1046 1 13V6ZM6 9C6 8.44772 6.44772 8 7 8H9C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10H7C6.44772 10 6 9.55228 6 9Z",
    fill: "currentColor"
  })));
}

export default SvgParcel;